import { TFunction } from 'react-i18next';

export const getLegalTypeOptions = (t: TFunction) => [
  { value: 'fop', label: t('legal_type_fop') },
  { value: 'tov', label: t('legal_type_tov') },
];

export const getStatusOptions = (t: TFunction) => [
  { value: true, label: t('status_active') },
  { value: false, label: t('status_inactive') },
];
